/**
 * Les TEXTES DE SEPTEMBRE de la compréhension de l'écrit (évaluations nationales), tels que le livre du quiz les
 * affiche quand une question n'a pas de texte propre (variante ou forme parallèle : leurs pages viennent de
 * generators/evalnat/supports.js). Sortis de l'ancien livre (QuestionSpecifiqueFR, supprimé le 12/10/2026) tels
 * quels ; le livre est LivreImmersif.
 */
import DocSommeil1 from '../../assets/DocSommeil1.PNG';
import DocSommeil2 from '../../assets/DocSommeil2.PNG';
// « Volcans sous la glace » (4e, campagne 2026) : images extraites du support du ministère.
import VolcansGlobe from '../../assets/VolcansGlobe.jpg';
import VolcansCarteAntarctique from '../../assets/VolcansCarteAntarctique.jpg';
import VolcansSchemaEruption from '../../assets/VolcansSchemaEruption.jpg';
import VolcansAnemones from '../../assets/VolcansAnemones.jpg';
import VolcansCrabes from '../../assets/VolcansCrabes.jpg';
import VolcansIslande from '../../assets/VolcansIslande.jpg';
  // Données hardcodées pour "Compréhension de l'écrit Archnée" niveau "6eme"
  const questionsData = {
    "compréhension de l'écrit arachné": {
      "6": {
        pages: [
          {
            page: 1,
            title: "Voici une légende tirée de la mythologie romaine.",
            content: `Arachné ne tenait sa célébrité ni de ses ancêtres ni de sa patrie : c'est à son art seul qu'elle devait toute sa gloire. [...] Le nom d'Arachné, fille d'un humble artisan, était célèbre dans toutes les villes de la province de Lydie¹. Elle habitait un joli petit village perdu au fin fond de la campagne, où pourtant se pressaient toutes les nymphes² de la région pour admirer ses travaux. Arachné était brodeuse, elle tissait des toiles magnifiques. C'était un plaisir pour la foule non seulement de contempler ses chefs-d'œuvre, mais encore de la voir au travail, tant ses mains étaient agiles ! Avec une grâce et une légèreté incomparable, elle dévidait la laine en pelotes arrondies, [...]. Bref, elle était si experte qu'on se mit à l'honorer comme une élève de Minerve, la glorieuse fille de Jupiter, la déesse protectrice des artisans et des brodeuses. Cependant, Arachné refuse cet éloge : par orgueil, elle ne peut admettre qu'on lui donne un professeur, même immortel !

¹ ancien pays d'Asie
² petites déesses`
          },
          {
            page: 2,
            title: "",
            content: `– Que la déesse vienne donc rivaliser avec moi, lance-t-elle un beau jour à ses admirateurs. Si je suis vaincue, j'accepterai tout ce que vous voudrez !

Furieuse, Minerve prend l'apparence d'une vieille femme : elle couvre sa tête de faux cheveux blancs ; elle s'appuie sur un bâton et avance toute courbée vers Arachné.

– On a tort de mépriser les vieillards, lui dit-elle d'une voix chevrotante. Les années leur donnent beaucoup d'expérience. Écoute mes conseils : certes, tu peux avoir l'ambition de surpasser toutes les mortelles de ton art, cependant, crois-moi, ne prétends pas égaler une déesse ! Si tu supplies Minerve de bien vouloir oublier ton orgueil téméraire et tes paroles offensantes, elle te pardonnera !

Mais Arachné jette sur la vieille femme un regard furieux. Elle quitte l'ouvrage qu'elle vient de commencer : elle a du mal à retenir sa main prête à la gifler ; la colère se lit sur son visage.`
          },
          {
            page: 3,
            title: "",
            content: `– Vieille folle ! réplique-t-elle à la déesse qu'elle ne reconnaît pas, le poids de l'âge qui courbe ton corps a aussi affaibli ta raison ! Quel malheur pour toi d'avoir vécu si longtemps ! Si tu as une fille, ou si ton fils a une femme, va donc leur faire la leçon ! Garde pour elle tes conseils : je sais me conseiller moi-même ! Ne crois surtout pas que tes paroles ont eu le moindre effet : je n'ai pas changé d'avis ! Pourquoi donc Minerve refuse-t-elle d'accepter mon défi ? pourquoi ne vient-elle pas elle-même ici ?

– Elle est venue ! s'écrie alors la déesse, et, soudain, elle abandonne son apparence de vieille femme pour se montrer dans toute sa puissance divine.

Vivement impressionnées, les nymphes la saluent, les femmes de Lydie s'inclinent avec respect devant elle. Seule Arachné n'est pas émue ; à peine rougit-elle, mais sa rougeur subite s'évanouit très vite sur son visage, comme le ciel qui se teinte de pourpre au lever du jour et qui blanchit dès les premiers rayons du soleil. Poussée par une folle ambition, la brodeuse persiste dans son entreprise : elle ne sait pas qu'elle court à sa ruine. La fille de Jupiter accepte le défi : finis les conseils ! place à la compétition !`
          },
          {
            page: 4,
            title: "",
            content: `Aussitôt Arachné et Minerve prennent place l'une en face de l'autre. Elles dressent leur métier à tisser, tendant la chaîne de leur toile qu'elles fixent au cadre. Un roseau sépare les fils ; entre les fils glisse la trame qui se déroule sous leurs doigts agiles conduite par la navette effilée ; puis les dents du peigne viennent resserrer les fils de trame dans les fils de chaîne. Les deux rivales se hâtent : elles ont roulé les pans de leur robe dans leur ceinture, elles guident leurs bras et leurs mains avec autant de rapidité que de précision ; le désir de vaincre leur fait oublier la fatigue du travail. Pour leurs riches tissus, elles emploient la pourpre³ venue de Tyr. Elles varient et mélangent les teintes avec tant de délicatesse que personne ne pourrait les distinguer à l'œil nu : sous leurs doigts, les nuances des couleurs brillent et se fondent exactement comme brillent et se fondent les couleurs de l'arc-en-ciel sous les rayons du soleil dans un ciel orageux. Elles mêlent aussi de longs fils d'or à la laine et de grands tableaux se dessinent sur leur tissu.

³ matière colorante d'un rouge vif`
          },
          {
            page: 5,
            title: "",
            content: `Chacune représente des exploits des dieux et des héros qui se sont passés dans des temps fort anciens. Sur sa toile, Minerve fait apparaître les douze grands dieux assis sur des trônes élevés au sommet du mont Olympe ; ils brillent de tout l'éclat de leur majesté : Jupiter auréolé de sa toute-puissance de maître du monde, Neptune, le trident à la main... La déesse se représente elle-même, armée de sa lance et de son bouclier, le casque sur la tête, la redoutable égide sur la poitrine. Elle dessine encore bien d'autres scènes où la fierté est en valeur, puis borde sa pièce de fins rameaux d'olivier entrelacés, symbole de paix.

Arachné, quant à elle, tisse une toile qui montre les mauvais comportements des dieux envers les humains.

Pour achever sa toile, Arachné l'orne d'une riche bordure où serpentent en festons légers des tiges de lierre entrelacées de fleurs. Son ouvrage est si beau que même Minerve ne pourrait y apporter aucune retouche.`
          },
          {
            page: 6,
            title: "",
            content: `La fille de Jupiter, furieuse du succès de sa rivale, déchire l'étoffe où sont si bien brodées les fautes des dieux. Elle tient encore sa navette à la main : trois ou quatre fois elle en frappe le front d'Arachné.

Se sentant humiliée, Arachné menace de se donner la mort.

Minerve, prise de pitié décide d'adoucir son destin.

– Vis donc, lui dit-elle, misérable ! [...] Et ne compte pas sur l'avenir : je veux que le même châtiment frappe toute ta descendance, y compris jusqu'à tes plus lointains représentants !

À ces mots, Minerve s'en va, mais avant de disparaître, elle a aspergé Arachné d'un [poison] tiré d'un mélange d'herbes vénéneuses choisies par la magicienne Hécate. Aussitôt sous l'effet de ce poison redoutable, [...] [Arachné devient] une araignée : elle exerce toujours son talent et continue à tisser sa toile.

D'après Annie Collognat, 25 Métamorphoses d'Ovide, 2007.`
          }
        ]  
      }
      
    },
    "compréhension de l'écrit document sommeil": {
    "6": {
      pages: [
        {
          page: 1,
          title: "Le sommeil",
          content: "image",
          imageUrl: DocSommeil1, // L'illustration humoristique avec le personnage au lit
          caption: "Illustration de Jacques Azam @MilanPresse"
        },
        {
          page: 2,
          title: "Le sommeil et les écrans",
          content: `Télé et ordinateur : les faux amis du sommeil

La télévision, l'ordinateur, les jeux vidéo sur console ou sur ordinateur, l'utilisation d'Internet et du téléphone mobile sont associés à des éveils et à un sommeil de médiocre qualité.

Les enfants qui regardent la télévision deux heures par jour la semaine et le weekend ont un coucher plus tardif. La durée de sommeil est diminuée en semaine et le lever est retardé le weekend.

Plus l'utilisation des écrans est importante, plus le retentissement est grand. Ainsi les enfants qui regardent la télévision plus de trois heures par jour pendant l'adolescence ont un risque plus élevé d'avoir des troubles du sommeil à l'âge adulte.

Comment ces médias influencent-ils le sommeil ?

Une perte de repères temporels

Les activités liées aux médias ne sont pas structurées dans le temps. Ces activités n'ont ni début ni fin clairement définis.`
        },
        {
          page: 3,
          title: "",
          content: `Le jeune n'est alors pas à l'écoute de son sommeil et laisse passer tous les signaux qui devraient le conduire à se coucher.

Une plus grande sédentarité

L'utilisation des écrans prend beaucoup de temps au détriment de l'activité physique. Or, la sédentarité est elle-même connue pour déstructurer le sommeil.

Un dérèglement hormonal

L'exposition à la lumière d'écran, juste avant le sommeil, affecte le rythme veille/sommeil en modifiant la sécrétion de l'hormone qui régule le rythme du sommeil et facilite l'endormissement : la mélatonine.

La lumière agit en augmentant le niveau d'activité et d'éveil et donc retarde l'endormissement.

Une augmentation du stress

Enfin, le contenu des programmes de télévision ou de certains jeux excessivement violents, donc excitants, peut entraîner des tensions et augmenter l'anxiété qui génère à son tour des difficultés d'endormissement.

D'après www.institut-sommeil-vigilance.org`
        },
        {
          page: 4,
          title: "Les conséquences du manque de sommeil sur la santé",
          content: `Lorsque l'enfant dort, son corps produit, en plus de la mélatonine, des hormones favorisant la croissance, les défenses immunitaires ou encore celles régulant son appétit.

Des études canadiennes ont montré qu'effectivement les adolescents ayant un sommeil altéré, et donc une baisse de production d'hormones, développeraient plus de risques de surpoids, d'obésité et seraient plus fragiles face aux maladies comme la grippe, le rhume. Leur taille adulte pourrait être aussi affectée.

D'autre part, la fatigue provoquée par des nuits plus courtes entraîne de l'irritabilité et des difficultés à réaliser des tâches simultanées et/ou complexes.

Le manque de sommeil a donc des répercussions sur la santé, la réussite scolaire des enfants mais aussi sur la vie future d'adulte.

D'après www.presse.inserm.fr`
        },
        {
          page: 5,
          title: "Le cycle du sommeil",
          content: "image",
          imageUrl: DocSommeil2, // Le diagramme circulaire du cycle du sommeil
          caption: "Un cycle dure 1H30 à 2H00. Pendant la nuit, notre corps effectue 4 à 6 cycles de sommeil."
        },
        {
          page: 6,
          title: "Qu'est-ce qu'un sommeil de qualité ?",
          content: `Selon plusieurs autorités sanitaires américaines, on peut dire qu'on a bien dormi si :

- au moins 85 % du temps total passé dans le lit est consacré au sommeil ;

- la phase d'endormissement dure moins de 30 minutes ;

- on ne se réveille pas plus d'une fois par nuit et pour une durée d'éveil nocturne de moins de 20 minutes.

D'après www.santemagazine.fr, 25 janvier 2017`
        }
      ]
    }},
    "compréhension de l'écrit petit chose": {
  "4": {
    pages: [
      {
        page: 1,
        title: "Texte littéraire : Alphonse Daudet, Le Petit Chose, 1868",
        content: `Le narrateur vient de terminer le lycée. Sa famille a été ruinée et il doit gagner sa vie. Il se rend donc au collège de Sarlande, pour être embauché comme « maitre d'études », sorte de surveillant des élèves en internat...

Sarlande est une petite ville des Cévennes, bâtie au fond d'une étroite vallée que la montagne enserre de partout comme un grand mur. Quand le soleil y donne, c'est une fournaise ; quand la tramontane souffle, une glacière...

Le soir de mon arrivée, la tramontane faisait rage depuis le matin ; et quoiqu'on fût au printemps, perché sur le haut de la diligence, je sentis, en entrant dans la ville, le froid me saisir jusqu'au cœur.

Les rues étaient noires et désertes... Sur la place d'armes, quelques personnes attendaient la voiture, en se promenant de long en large devant le bureau mal éclairé.

À peine descendu de mon impériale, je me fis conduire au collège, sans perdre une minute. J'avais hâte d'entrer en fonctions.`
      },
      {
        page: 2,
        title: "",
        content: `Le collège n'était pas loin de la place ; après m'avoir fait traverser deux ou trois larges rues silencieuses, l'homme qui portait ma malle s'arrêta devant une grande maison, où tout semblait mort depuis des années.

– C'est ici, dit-il, en soulevant l'énorme marteau de la porte...

Le marteau retomba lourdement, lourdement... la porte s'ouvrit d'elle-même... Nous entrâmes.

J'attendis un moment sous le porche, dans l'ombre. L'homme posa sa malle par terre, je le payai, et il s'en alla bien vite... Derrière lui, l'énorme porte se referma lourdement, lourdement... Bientôt après, un portier somnolent, tenant à la main une grosse lanterne, s'approcha de moi.

– Vous êtes sans doute un nouveau ? me dit-il d'un air endormi.

Il me prenait pour un élève...

– Je ne suis pas un élève du tout. Je viens ici comme maitre d'études ; conduisez-moi chez le principal...

Le portier parut surpris ; il prit sa lanterne, et je le suivis.

Le collège me sembla immense...`
      },
      {
        page: 3,
        title: "",
        content: `D'interminables corridors, de grands porches, de larges escaliers avec des rampes de fer ouvragé..., tout cela vieux, noir, enfumé...

Le portier m'apprit qu'avant 89 la maison était une école de marine, et qu'elle avait compté jusqu'à huit cents élèves, tous de la plus grande noblesse.

Comme il achevait de me donner ces précieux renseignements, nous arrivions devant le cabinet du principal... M. Cassagne poussa doucement une double porte matelassée, et frappa deux fois contre la boiserie.

Une voix répondit : « Entrez ! » Nous entrâmes.

C'était un cabinet de travail très vaste, à tapisserie verte. Tout au fond, devant une longue table, le principal écrivait à la lueur pâle d'une lampe dont l'abat-jour était complètement baissé.

– Monsieur le principal, dit le portier en me poussant devant lui, voilà le nouveau maitre qui vient pour remplacer M. Serrières.

– C'est bien, fit le principal sans se déranger.

Le portier s'inclina et sortit. Je restai debout au milieu de la pièce, en tortillant mon chapeau entre mes doigts.`
      },
      {
        page: 4,
        title: "",
        content: `Quand il eut fini d'écrire, le principal se tourna vers moi, et je pus examiner à mon aise sa petite face pâlotte et sèche, éclairée par deux yeux froids, sans couleur. Lui, de son côté, releva, pour mieux me voir, l'abat-jour de la lampe et accrocha un lorgnon à son nez.

– Mais c'est un enfant ! s'écria-t-il en bondissant sur son fauteuil. Que veut-on que je fasse d'un enfant !

Pour le coup, j'eus une peur terrible ; je me voyais déjà dans la rue, sans ressources... J'eus à peine la force de balbutier deux ou trois mots et de remettre au principal la lettre d'introduction que j'avais pour lui.

Le principal prit la lettre, la lut, la relut, la plia, la déplia, la relut encore, puis il finit par me dire que, grâce à la recommandation toute particulière du recteur et à l'honorabilité de ma famille, il consentait à me prendre chez lui, bien que ma grande jeunesse lui fît peur. Il entama ensuite de longues déclamations sur la gravité de mes nouveaux devoirs ; mais je ne l'écoutais plus. Pour moi, l'essentiel était qu'on ne me renvoyât pas ; j'étais heureux, follement heureux. J'aurais voulu que M. le principal eût mille mains et les lui embrasser toutes.`
      },
      {
        page: 5,
        title: "",
        content: `Un formidable bruit de ferraille m'arrêta dans mes effusions. Je me retournai vivement et me trouvai en face d'un long personnage, à favoris rouges, qui venait d'entrer dans le cabinet sans qu'on l'eût entendu : c'était le surveillant général.

Sa tête penchée sur l'épaule [...], il me regardait avec le plus doux des sourires, en secouant un trousseau de clés de toutes dimensions, suspendu à son index. Le sourire m'aurait prévenu en sa faveur, mais les clés grinçaient avec un bruit terrible, – frinc ! frinc ! frinc ! –, qui me fit peur.

– Monsieur Viot, dit le principal, voici le remplaçant de M. Serrières qui nous arrive.

M. Viot s'inclina et me sourit le plus doucement du monde. Ses clés, au contraire, s'agitèrent d'un air ironique et méchant comme pour dire : « Ce petit homme-là remplacer M. Serrières ! allons donc ! allons donc ! »

Le principal comprit aussi bien que moi ce que les clés venaient de dire, et ajouta avec un soupir : « Je sais qu'en perdant M. Serrières, nous faisons une perte presque irréparable (ici les clés poussèrent un véritable sanglot...) ; mais je suis sûr que si M. Viot veut bien prendre le nouveau maitre sous sa tutelle spéciale, et lui inculquer`
      },
      {
        page: 6,
        title: "",
        content: `ses précieuses idées sur l'enseignement, l'ordre et la discipline de la maison n'auront pas trop à souffrir du départ de M. Serrières. »

Toujours souriant et doux, M. Viot répondit que sa bienveillance m'était acquise et qu'il m'aiderait volontiers de ses conseils ; mais les clés n'étaient pas bienveillantes, elles. Il fallait les entendre s'agiter et grincer avec frénésie : « Si tu bouges, petit drôle, gare à toi. »

– Monsieur Eyssette, conclut le principal, vous pouvez vous retirer. Pour ce soir encore, il faudra que vous couchiez à l'hôtel... Soyez ici demain à huit heures... Allez...

Et il me congédia d'un geste digne.

M. Viot, plus souriant et plus doux que jamais, m'accompagna jusqu'à la porte ; mais, avant de me quitter, il me glissa dans la main un petit cahier.

– C'est le règlement de la maison, me dit-il. Lisez et méditez...

Puis il ouvrit la porte et la referma sur moi, en agitant ses clés d'une façon... frinc ! frinc ! frinc !

D'après Alphonse Daudet, Le Petit Chose, 1868.`
      }
    ]
  }
}
,
// Campagne 2026 (texte documentaire de 4e, Gaspillage retiré : ses questions n'existent plus). Les questions
// renvoient à « (page 1) » … « (page 5) » : la page N du lecteur est la partie N du document. Texte et images
// de la « Retranscription des supports de compréhension de l'écrit » du ministère, pages 3 à 6.
"compréhension de l'écrit volcans sous la glace": {
    "4": {
      pages: [
        {
          page: 1,
          surtitre: "Texte documentaire : « Volcans sous la glace »",
          title: "Des volcans sous la glace",
          content: `L'Antarctique réserve bien des surprises aux scientifiques. Il est en effet particulièrement compliqué d'étudier cette immensité, certes magnifique, mais dont le climat est glacial : la température la plus basse du monde, - 98°C, y a été enregistrée.

Or, cachée sous la surface de la vaste calotte glaciaire de l'Antarctique, se dissimule la plus grande région volcanique sur Terre.`,
          images: [{ src: VolcansGlobe, alt: "Globe terrestre : l'Antarctique au pôle Sud" }],
          source: "Source de l'image : Carl Voyer / Lelivrescolaire.fr"
        },
        {
          page: 2,
          title: "La plus grande chaine volcanique au monde",
          content: `47 volcans cachés sous la glace avaient été précédemment repérés par les chercheurs. Depuis 2016, il faut y ajouter les 91 volcans nouvellement découverts. Avec un total de 138 volcans, l'Antarctique devient la première chaine volcanique au monde. D'après les géologues et les glaciologues, cette chaine volcanique présenterait de nombreuses similitudes avec la crête volcanique de l'Afrique de l'Est qui était auparavant considérée comme la zone contenant le plus grand nombre de volcans.

Robert Bingham, chercheur à l'université d'Édimbourg, témoigne : « Il est fascinant de découvrir une vaste gamme de volcans dans ce continent relativement inexploré ». C'est en effet la première fois qu'un inventaire précis de l'activité volcanique de cette région est réalisé. Cette prouesse a été rendue possible par l'utilisation d'un radar à pénétration de sol, capable de sonder une épaisseur de glace qui peut atteindre 3000 mètres : ces volcans, d'une hauteur variant de 100 à 3850 mètres, ont tous la particularité d'être recouverts par des glaciers. Néanmoins, bien qu'enfouis sous la glace, ces volcans ne sont pas forcément inactifs et pourraient entrer en éruption.`,
          images: [{ src: VolcansCarteAntarctique, alt: "Carte de l'Antarctique : situation des principaux volcans" }],
          source: "Source de l'image : laterredufutur.com, 2020."
        },
        {
          page: 3,
          title: "Un volcanisme actif",
          content: `Les chercheurs pensent depuis longtemps que les éruptions volcaniques existent sous la glace. Cependant, il a fallu attendre 2012 et d'importants progrès techniques pour que soit relevée pour la première fois de manière précise l'activité volcanique de l'Antarctique car la glace et la neige qui recouvrent les volcans rendaient difficile la détection visuelle des éruptions.

Pourtant, des signes d'agitation accompagnent les éruptions volcaniques : par exemple les tremblements de terre, la déformation de la surface du sol, des émissions de gaz ou encore des anomalies thermiques. Les scientifiques utilisent donc des instruments comme les sismomètres et des techniques telles que la cartographie par satellite pour surveiller et relever l'activité volcanique de cette région.`,
          images: [{ src: VolcansSchemaEruption, alt: "Schéma de principe d'une éruption sous-glaciaire" }],
          source: "Source de l'image : Graphic News, 2010."
        },
        {
          page: 4,
          title: "Un écosystème lié à la présence des volcans",
          content: `À proximité de ces volcans, dans l'océan qui borde la côte Est de l'Antarctique, des scientifiques britanniques ont découvert en 2012 un « monde perdu » à environ 2500 mètres de profondeur, abritant de nombreuses espèces animales et végétales non répertoriées.

Ces espèces auraient réussi à vivre à cette profondeur et dans une eau glacée grâce aux volcans sous-marins. En rejetant des volutes de fumée noire, ceux-ci réchauffent l'eau jusqu'à 380°C. À quelques centaines de mètres de la fumée, la température retombe à environ 20°C : c'est précisément là que vivent la plupart des espèces découvertes. L'obscurité qui règne à de telles profondeurs n'aurait pas dû non plus permettre à ces animaux et végétaux de survivre. Mais en assimilant puis en transformant les éléments chimiques rejetés par les volcans, ils ont réussi à trouver une énergie suffisante à leur survie.

Les chercheurs ont observé des colonies marines d'espèces de crabes, de pieuvres et d'étoiles de mer parfaitement inconnues. En tout, deux douzaines de nouvelles espèces ont été découvertes. Celle qui a été trouvée en plus grand nombre, avec près de 600 individus par colonie, compte des spécimens de « crabes yéti » qui peuvent mesurer jusqu'à 16 centimètres chacun. Une étoile de mer à 7 branches a également été découverte et d'autres espèces telles que des escargots de mer ou des anémones de mer ont été observées. D'après le Dr Rogers de l'université d'Oxford, certains spécimens portaient des traces de brulures, ce qui laisse entendre qu'ils se sont trop approchés des cheminées volcaniques. Par ailleurs, les chercheurs ont été incapables d'attraper une variété de pieuvre qu'ils pensent être inconnue.`,
          images: [
            { src: VolcansAnemones, alt: "Anémones de mer photographiées lors de l'exploration sous-marine" },
            { src: VolcansCrabes, alt: "Crabes photographiés lors de l'exploration sous-marine" }
          ],
          legende: "Photographies prises par les chercheurs lors de leur exploration sous-marine.",
          source: "Source des images : Oxford university, Southampton university, British Antartic Survey"
        },
        {
          page: 5,
          title: "L'éruption d'un volcan sous-glaciaire en Europe",
          content: `En avril 2010, le volcan Eyjafjöll, situé sous le glacier Eyjafjallajökull, en Islande, entre en éruption et libère un panache de fumée s'élevant à près de 8000 mètres d'altitude. L'éruption ne fait pas de victimes, mais le nuage de poussières volcaniques est d'une taille exceptionnelle et, poussé par les vents, il descend très rapidement vers le nord de l'Europe.

En raison du risque représenté par les particules de cendres pour les avions en vol, les compagnies aériennes annulent leurs vols et les espaces aériens de plusieurs pays européens sont même fermés et ce, pendant plusieurs jours. C'est la plus longue interruption du trafic aérien depuis la fin de la Seconde Guerre mondiale : sur une semaine, près de 100 000 vols sont annulés, laissant 10 millions de passagers au sol. Les répercussions économiques sont importantes. L'éruption aura également des conséquences locales en Islande : certaines zones sont temporairement évacuées.

L'évènement a mis en évidence les défis que les éruptions volcaniques de ce type peuvent poser à la société moderne, en particulier en ce qui concerne le transport aérien.`,
          images: [{ src: VolcansIslande, alt: "Photographie aérienne au-dessus des glaciers en Islande" }],
          legende: "Photographie aérienne au-dessus des glaciers en Islande",
          source: "Source de l'image : lepoint.fr, 2010."
        }
      ]
    }
  }
};

/**
 * Les pages d'un texte de compréhension : celles d'une variante ou d'une forme parallèle (`pages`), sinon le texte
 * de septembre (questionsData, par type de l'item et niveau, apostrophe typographique comprise). Un texte ou un
 * niveau inconnu donne une liste vide, jamais une page qui plante. Partagé avec le livre du quiz (LivreImmersif).
 */
export const pagesDuLivre = ({ niveau, typeLabel, pages }) => {
  if (pages?.length) return pages;
  const type = typeLabel?.toLowerCase().replace(/’/g, "'") || '';
  return questionsData[type]?.[String(niveau ?? '').toLowerCase()]?.pages || [];
};
